import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (typeof performance !== 'undefined' && typeof performance.mark === 'function') {
  performance.mark('propdesk:app:start');
}

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => {
    if (typeof performance !== 'undefined' && typeof performance.mark === 'function') {
      performance.mark('propdesk:app:bootstrapped');
    }
  })
  .catch(err => console.error(err));

